<!--

	Title and list of members with avatar description

-->

<template>
	<div>
		<h3 v-tr="title" />
		<vue-list :items="members" template="team-member" />
	</div>
</template>

<script lang="ts">
import { Component, Prop, toNative, Vue } from "vue-facing-decorator";
import SearchableList from "@/Control/Vue/Lists/Searchable/SearchableList.vue";
import VueList from "@/Control/Vue/Lists/VueList/VueList.vue";
import { MiaPlaza } from "@/Reinforced.Typings";

@Component({
	components: {
		SearchableList,
		VueList,
	},
})
export class TeamMemberList extends Vue {
	@Prop({required: true, type: Array, default: []}) members!: MiaPlaza.Control.Vue.ITeamMember[];
	@Prop({required: true, type: String}) title!: string;
}

export default toNative(TeamMemberList);
</script>
